export default __webpack_public_path__ + "static/media/Manlyk.e9c0507b.jpg";